import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper";

// Service
import {
    CreateContent,
    GetContentById,
    UpdateContent,
} from "./services/Services.js"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `content-banner`
const _pageName  = `Content Banner`
const _routePermission = `home:content-banner`

const OrganizationChartTemplate = ({ 
    pageView = "create", 
    componentKey = "",
}) => {
    // POPUP
    const { mAlert } = useContext(ModalContext)

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? "TH"
    const qMainId = 1
    const navigate = useNavigate()

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({

        bannerDesktop: Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner Desktop",
            (value) => value && Object.keys(value).length > 0
        ).required("Please Upload Banner Desktop"),

        bannerMobile: Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner Mobile",
            (value) => value && Object.keys(value).length > 0
        ).required("Please Upload Banner Mobile"),

        contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
        contentStatus: Yup.string().max(100).required("Please Enter Display"),
    })

    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] =
        useState(validationSchema)

    const initialValues = {
        contentId: "",

        // Content
        bannerDesktop: {},
        bannerDesktop: {},

        contentUpdateDate: moment().format("YYYY-MM-DD"),
        contentStatus: "active",
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
            const payload = {
                id: qMainId,
                contentId: values.contentId ? values.contentId : undefined,
                langId: qLang,

                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,

                attachmentData: {
                    // contentBannerDesktop: values.bannerDesktop,
                    // contentBannerMobile: values.bannerMobile,
                },

                contentAttachmentData: {
                    contentBannerDesktop: values.bannerDesktop,
                    contentBannerMobile: values.bannerMobile,
                },
            }

            console.log("🚀 ~ onSave ~ payload:", payload)

            setWaitSendData(true)
            if (pageView === "update") {
                API.fetchUpdateContent(payload)
            } else {
                API.fetchCreateContent(payload)
            }
        },
    })

    const preFilInput = (resData = {}) => {
        console.log("🚀 ~ preFilInput ~ resData:", resData)
        // resetForm(validation.values, initialValues)

        // ถ้าไม่หน่วงมันจะแย่งกันทำ
        validation.setFieldValue(
            "bannerDesktop",
            resData?.contentContentBannerDesktop ?? ""
        )
        validation.setFieldValue(
            "bannerMobile",
            resData?.contentContentBannerMobile ?? ""
        )

        validation.setFieldValue(
            "contentUpdateDate",
            resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
        )
        validation.setFieldValue(
            "contentStatus",
            resData?.contentStatus ?? "active"
        )
    }

    const API = {
        fetchGetContentById: async payload => {
            try {
                const response = await GetContentById({
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload) => {
            try {
                const response = await CreateContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContent: async (payload) => {
            try {
                const response = await UpdateContent({
                    data: payload,
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            const payload = { id: qMainId }
            setContentLoading(true)
            API.fetchGetContentById(payload)
        }
    }, [qLang])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: "10px",
        border: "1px solid black",
        margin: "5px",
        borderRadius: "8px",
        background: "#f9f9f9",
        transition: "transform 0.2s ease, background-color 0.3s ease",
    }

    const mapValues = (list = []) =>
        list.map(item => {
            const newObj = {
                attachmentId: item.attachmentId,
                sequence: item.sequence,
            }
            return newObj
        })
    
    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {contentLoading ? (
                        <Spinners setLoading={setContentLoading} />
                    ) : (
                        <Row>
                            <Col className="col-12">
                                <FormikProvider value={validation}>
                                    <Form
                                        className="form-horizontal"
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Col className="col-8">
                                                <Row>
                                                    <Col className="col-12">
                                                        <Card>
                                                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                                <i className="bx bx-cube-alt"></i> {_pageName}
                                                            </h5>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col className="col-6 mb-3">
                                                                        {/* {JSON.stringify(validation.values.bannerDesktop)} */}
                                                                        <div className="col-md-12">
                                                                            <PopupAttachment
                                                                                typeDetail="single"
                                                                                typeUpload="ImageMap"
                                                                                upload="Image"
                                                                                prefixName={`${_routeLink}-desktop`}
                                                                                label={`${_pageName} Desktop`}
                                                                                required={true}
                                                                                description="description"
                                                                                widthSize={2160}
                                                                                heightSize={1080}
                                                                                value={validation.values.bannerDesktop}
                                                                                onChange={(value = {}, index) => {
                                                                                    console.log("🚀 onChange ~ value:", value)
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerDesktop', value)
                                                                                }}
                                                                                onRemove={(index) => {
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerDesktop', {})
                                                                                }}
                                                                            />
                                                                            {validation.touched.bannerDesktop && validation.errors.bannerDesktop && (
                                                                                <div type="invalid" className="invalid-feedback d-block">
                                                                                    {validation.errors.bannerDesktop}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-6 mb-3">
                                                                        {/* {JSON.stringify(validation.values.bannerMobile)} */}
                                                                        <div className="col-md-12">
                                                                            <PopupAttachment
                                                                                typeDetail="single"
                                                                                typeUpload="ImageMap"
                                                                                upload="Image"
                                                                                prefixName={`${_routeLink}-mobile`}
                                                                                label={`${_pageName} Mobile`}
                                                                                required={true}
                                                                                description="description"
                                                                                widthSize={2160}
                                                                                heightSize={1080}
                                                                                value={validation.values.bannerMobile}
                                                                                onChange={(value = {}, index) => {
                                                                                    console.log("🚀 onChange ~ value:", value)
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerMobile', value)
                                                                                }}
                                                                                onRemove={(index) => {
                                                                                    console.log("🚀 onChange ~ index:", index)
                                                                                    validation.setFieldValue('bannerMobile', {})
                                                                                }}
                                                                            />
                                                                            {validation.touched.bannerMobile && validation.errors.bannerMobile && (
                                                                                <div type="invalid" className="invalid-feedback d-block">
                                                                                    {validation.errors.bannerMobile}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col className="col-4">
                                                <Card
                                                    outline
                                                    color="primary"
                                                    className="border sticky-element"
                                                >
                                                    <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                        <i className="bx bx-check"></i> Tools Box
                                                    </h5>
                                                    <CardBody>
                                                        <Row>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Switch Language
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputLang
                                                                        widthfull
                                                                        pageView={pageView}
                                                                        forceRoute={false}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Written at
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputGroup>
                                                                        <Flatpickr
                                                                            className="form-control d-block"
                                                                            options={{
                                                                                dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                            }}
                                                                            value={
                                                                                validation.values.contentUpdateDate
                                                                                    ? moment(
                                                                                        validation.values
                                                                                            .contentUpdateDate,
                                                                                        "YYYY-MM-DD"
                                                                                    ).toDate()
                                                                                    : null
                                                                            }
                                                                            disabled={true}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                disabled
                                                                            >
                                                                                <i
                                                                                    className="fa fa-calendar"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </InputGroup>
                                                                    {validation.touched.contentUpdateDate &&
                                                                        validation.errors.contentUpdateDate && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.contentUpdateDate}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <Input type="hidden" value="active" />
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Display
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Select
                                                                        placeholder="Select Status"
                                                                        value={fn_helper.FNFORM.getObjectValue(
                                                                            STATUS_OPTION,
                                                                            `${validation.values.contentStatus}`
                                                                        )}
                                                                        onChange={value =>
                                                                            validation.setFieldValue(
                                                                                "contentStatus",
                                                                                value.id
                                                                            )
                                                                        }
                                                                        getOptionValue={option => option.id}
                                                                        getOptionLabel={option => option.name}
                                                                        options={STATUS_OPTION}
                                                                        className={`select2-selection ${validation.touched.contentStatus &&
                                                                                validation.errors.contentStatus
                                                                                ? "input-err"
                                                                                : ""
                                                                            }`}
                                                                        isDisabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.contentStatus &&
                                                                        validation.errors.contentStatus && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.contentStatus}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                    <CardFooter>
                                                        <Row>
                                                            {/* <Col className="text-start">
                                                                <Button
                                                                    color="danger"
                                                                    className="btn btn-danger"
                                                                    onClick={() =>
                                                                        navigate(`/${_routeLink}/${qLang}`)
                                                                    }
                                                                >
                                                                    Back
                                                                </Button>
                                                            </Col> */}
                                                            <Col className="text-end">
                                                                {pageView !== "view" && (
                                                                    <Button
                                                                        type="submit"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Save{" "}
                                                                        {waitSendData ? (
                                                                            <Spinner size="sm" color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </CardFooter>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Form>
                                </FormikProvider>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(OrganizationChartTemplate)
